<template>
  <div
    class="sidebar"
    :class="
      showSideBar ? 'sidebar-open' : forceClosing ? 'sidebar-closing' : ''
    "
  >
    <div class="sidebar-block"></div>
    <div class="sidebar-menu-container">
      <div class="sidebar-menu">
        <div class="sidebar-floating">
          <div class="d-flex flex-column justify-content-between h-100">
            <div>
              <div
                class="d-flex justify-content-between align-items-center mx-3"
                style="width: 205px; margin-bottom: 10px;"
              >
                <div class="logo-container flex-grow-1">
                  <div class="logo"></div>
                </div>
                <button
                  type="button"
                  class="button-collapse"
                  @click="toggleCollapsedSidebar"
                >
                  <i class="fa fa-arrow-left"></i>
                </button>
              </div>
              <div
                v-for="sidebarItem in sidebarItemsStart"
                :key="sidebarItem.key"
              >
                <sidebar-menu-item
                  v-if="hasCurrentLocationAccessToSideBatItem(sidebarItem.key)"
                  :item="sidebarItem"
                  :selected="sidebarItem.key == selectedSideBarItem"
                />
              </div>
            </div>
            <div>
              <div
                v-for="sidebarItem in sidebarItemsEnd"
                :key="sidebarItem.key"
              >
                <sidebar-menu-item
                  :item="sidebarItem"
                  :selected="sidebarItem.key == selectedSideBarItem"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import {
  getSidebarCollapsed,
  setSidebarCollapsed
} from "../../helpers/session";
import SidebarMenuItem from "./SidebarMenuItem.vue";

export default {
  name: "Sidebar",
  components: { SidebarMenuItem },
  data() {
    return {
      showSideBar: getSidebarCollapsed() ? false : true,
      forceClosing: false
    };
  },
  methods: {
    ...mapMutations("layout", ["setSelectedSideBarItem", "setSidebarChange"]),
    toggleCollapsedSidebar() {
      this.showSideBar = !this.showSideBar;
      this.forceClosing = true;
      setTimeout(() => (this.forceClosing = false), 750);
      this.setSidebarChange();
      setSidebarCollapsed(this.showSideBar ? "" : "collapsed");
    }
  },
  computed: {
    ...mapState("layout", {
      sidebarItemsStart: state => state.sidebarItemsStart,
      sidebarItemsEnd: state => state.sidebarItemsEnd,
      selectedSideBarItem: state => state.selectedSideBarItem
    }),
    ...mapGetters("layout", ["hasCurrentUserPermission"]),
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    ...mapGetters("layout", ["hasCurrentLocationAccessToSideBatItem"])
  }
};
</script>

<style scoped>
.sidebar {
  display: flex;
  align-items: stretch;
}

.sidebar-menu-container {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  overflow: hidden;
}

.sidebar-menu {
  position: relative;
  width: 100%;
  height: 100%;
}

.sidebar-block,
.sidebar-menu,
.sidebar-floating {
  width: 60px;
  transition: width 750ms ease;
}

.sidebar.sidebar-open .sidebar-block,
.sidebar.sidebar-open .sidebar-menu,
.sidebar.sidebar-open .sidebar-floating,
.sidebar:not(.sidebar-closing):hover .sidebar-menu,
.sidebar:not(.sidebar-closing):hover .sidebar-floating {
  width: 240px;
}

.sidebar-floating {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #363abb;
  z-index: 15;
  overflow-y: auto;
}

.logo-container {
  position: relative;
  height: 32px;
  margin: 14px 0;
  clip-path: inset(0 149px 0 0);
  transition: clip-path 750ms ease;
}

.sidebar-open .logo-container,
.sidebar:hover .sidebar-floating .logo-container,
.sidebar:hover .sidebar-floating .logo-container {
  clip-path: inset(0 0 0 0);
}

.logo {
  position: absolute;
  width: 137px;
  height: 100%;
  background-image: url("../../assets/logos/Logo With EHR - No BG-Negative.png");
  background-size: contain;
  background-repeat: no-repeat;
}

.button-collapse {
  color: #969696;
  background-color: white;
  border: none;
  border-radius: 5px;
  padding: 2px 6px;
  transform: scale(0.9);
}

.fa-arrow-left {
  transform: rotate(180deg);
  transition: transform 375ms ease;
}

.sidebar.sidebar-open .fa-arrow-left {
  transform: rotate(0deg);
}
</style>
